import { useEffect, useState } from "react";
import { useAddMemberMutation } from "../../features/teams/teamsApi";
import Select from "react-select";
import { useGetAllUsersQuery } from "../../features/users/usersApi";
import Error from "../ui/Error";
import { useDispatch, useSelector } from "react-redux";
import { controlMemberModal } from "../../features/teams/teamsSlice";

export default function MemberModal({ open, team }) {
  //Dispatcher
  const dispatch = useDispatch();

  //Logged in User
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};

  //initial Variables
  const { members } = team || {};
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [error, setError] = useState();

  //Queries
  const [addMember] = useAddMemberMutation();
  const { data: allUsers } = useGetAllUsersQuery();

  useEffect(() => {
    if (selectedTeam.value) {
      setError();
    } else {
      setError("Please select a member");
    }
  }, [selectedTeam]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedTeam.value) {
      const newMembers = members.concat("/" + selectedTeam?.value?.email);
      await addMember({
        id: team?.id,
        data: {
          ...team,
          members: newMembers,
        },
        user: loggedInUser,
      });
      dispatch(controlMemberModal());
    } else {
      setError("Please select a member");
    }
  };

  const allMembers = members?.split("/");

  const filteredOptions = allUsers?.filter(
    (user) => !allMembers?.includes(user.email)
  );

  const options = filteredOptions?.map((user) => {
    return {
      value: { name: user?.name, email: user?.email },
      label: user?.name,
    };
  });

  return (
    open && (
      <>
        <div
          onClick={() => {
            dispatch(controlMemberModal());
            setSelectedTeam([]);
          }}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Add Memeber
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <Select
                name="members"
                placeholder="Select member"
                options={options}
                noOptionsMessage={() => "No Members Available"}
                onChange={setSelectedTeam}
              />
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              >
                Add
              </button>
            </div>
            {error && <Error message={error} />}
          </form>
        </div>
      </>
    )
  );
}
